import { render, staticRenderFns } from "./AnalyticsStatsCard.vue?vue&type=template&id=023ba0d4&scoped=true&"
import script from "./AnalyticsStatsCard.vue?vue&type=script&lang=js&"
export * from "./AnalyticsStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsStatsCard.vue?vue&type=style&index=0&id=023ba0d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ba0d4",
  null
  
)

export default component.exports